<app-navbar id="redirect_setting_msg1"></app-navbar>
<app-sidenav id="redirect_setting_msg2"></app-sidenav>
<app-body id="redirect_setting_msg3"></app-body>
